import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";

import whatAltRoutes from "../images/AlternateRouteCropTeal.png"
import whatTapeMeasure from "../images/BespokeTapeMeasurePaleMauve.png"
import whatriskNZCht1 from "../images/riskNZghgChtGreen.jpg"
// import what from "../images/[risk2NZ Capture1].jpg"
// import what from "../images/[risk2NZ Capture1].jpg"
import whatModelScheme from "../images/ModelSchemaPaleMauve.jpg"


const carouselHeight = "150px";
const What = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { whatSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [links, setLinks] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
    if (whatSubPage) {
      const url = whatSubPage.replace(/-/g, " ");
      setLinks(url);
      const finalString = url.split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `What (${pageTitle})`,
      link: `/what/${whatSubPage}`,
    },
  ];

  useEffect(() => {
    getRouterData();
  }, [whatSubPage]);

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={`What? <span style="font-size:1.2rem;color:rgba(84,77,160,1);">- Risk Quantification Tools to aid Mitigation</span> `}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={whatAltRoutes}
                title="Pre-run scenarios"
                objectFit="fill"
                subTitle="Test Sensitivities - Model-Based Scenarios"
                borderColor={
                  links == "prerun scenarios"
                    ? borderColorToHighlight
                    : "none"
                }

                body={`Using <a title="macro Global Econometric Model">mGEM </a>, we overlay latest <b>Official macro/budget projections</b> (eg from OBR, IMF, OECD) as a central forecast baseline. And business subscribers to MEF Apps - such as <a title="risks to Net Zero" href='/what/risk2NZ-app'> risk2NZ </a> - can view the scenario testing of such official projections to <b>quantify risks</b> around the key drivers
                of <i>their</i> business activity across Economies, Industries, Energy-Use, GHG Emissions and Financial investments/Assets & various Esg metrics.`}
              />
              <CustomizedAccordions
                title="Relevant, Pre-configured Scenarios"
                body={`Online DIY scenarios allow all key exogenous/other inputs (eg Interest or Tax rates) to be changed to explore sensitivities of official forecasts. Animated country output charts & Global, geographic map-impacts help understand & visualise scenario impacts.
                These are particularly useful for the teaching of applied Economics/Globalisation in the University or CPD classroom.
                Visualising the impacts of MEF Pre-run scenarios are available in all the subject <a title="risk2NZ Tabs" href='/what/risk2NZ-app'> Tabs </a> in the risk2NZ App`}
              />
              {/* [whatSubPage].tsx Need the Tabs link in line above to open the risk2NZ Tabs Accordion rather than the risk2NZ Card above */}

              <CustomizedAccordions
                title="Powering Bespoke Client Satellite Models"
                body={`MEF's pre-configured scenarios will normally be wide-ranging enough to satisfy most users of such macroeconomic sensitivity.
                Although available mainly via MEF Apps - such as <b>risk2NZ</b> - such scenario outputs are also available to consultancy clients to drive their
                own in-house analysis. Many firms/analysts need to be aware (and quantify impacts of) global uncertainties to business operations, but do <i>not </i>
                wish to carry the overhead of running global economic/energy models `}
              //                Alternatively, MEF can produce bespoke/detailed scenarios for clients either from a standard global forecast base or from a tailored forecast base.
              //                Where clients have pre-existing bespoke models, these can be driven by MEF's pre-run macro/energy scenarios to illustrate domain-level impacts of global risks/uncertainties
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={whatTapeMeasure}
                title="Bespoke - Scenarios & Models"
                objectFit="contain"
                subTitle="Quantify Macro, Energy & Portfolio Risk"
                borderColor={
                  links == "bespoke scenariosModels"
                    ? borderColorToHighlight
                    : "none"
                }
                body="Some users need to explore & quantify specific risk concerns eg the plausibility of some official forecast assumptions
                (eg for Interest or Tax rates). Using the <b>wide coverage of the MEF model suite</b>, we are usually able to capture/model <i>most</i> specialist risk requirements.
                If not, with its Bespoke services, MEF can build <b>customised, specialist models for clients</b> that take external scenario drivers (eg from MEF's global modal suite)
                to give globally-consistent results"
              />
              <CustomizedAccordions
                title="Bespoke Scenarios - Macro/Energy/Financial "
                body="Some clients will need to move beyond MEF's pre-configured Macroeconomic/Energy scenarios in order to conduct more specialised risk
                analysis & quantification. Perhaps this is simply to obtain/inspect alternative (Global) macro outturns or to act as drivers for the client's own
                free-standing models.<br><br>"     //                [SAI CASE STUDY LINK]
              // Each quarter, MEF produces several pre-configured scenarios (see previous examples) which cover significant current areas of macro risk at both Global and/or UK levels.
              // Some of these can be accessed through the risk2NZ App or via subscription. For Fund Managers MEF can explore/quantify potential fund risk from key national/global macro & environmental/Esg risks & threats via the Portfolio interrogation form.<br><br></br>
              />
              <CustomizedAccordions
                title="Bespoke Models - Client Satellite Models"
                body={`Given sufficient domain-level data exists, MEF can estimate (structural) models for clients that are either free-standing or recursively-driven
                by outputs from MEF's global model suite. This allows client's own risk scenario/analysis to be fully-consistent with
                Global/national economic drivers. In principle, any client model can be constructed as along as there is sufficient domain-level backdata and
                there are plausible driver variables covered in MEF's model suite that can be formally tested in regression analysis.`}
              //                eg1 <b>Exporters/SMEs</b> - managers can (cost-effectively) explore potential trading risk & opportunities in key global/national industry sectors.                 <br><br>
              //                eg2 <b>Investment Committees</b> - analysts and consultants can...[   ]<br><br>
              //                eg3 <b>Energy/Emissions Analysts</b> - Environmental analysts and consultants working with Net Zero pathways & decarbonisation can...[   ]<br><br>
              //                see -  <a href='/why/case-study/DAS'> Client Case Study - DAS</a>
              />
              <CustomizedAccordions
                title="Portfolio Esg Rating"
                body={`By deploying both the iGEM & eGEM model modules, MEF can construct unique "hard-data" Esg measures - these are referred to as "Esg" as they
                focus on more measurable & objective measures of Carbon intensity - namely GHG Emissions. By analysing the Country-Sector exposure of the
                allocated assets, MEF can create a weighted sum of emissions exposure for a particular fund or Portfolio. This also allows MEF
                to then explore the impacts of various GreenTech shocks (eg a surprise, "early" diffusion of commercial Nuclear Fusion) on national Energy sectors.`}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={whatriskNZCht1}
                title="risk2NZ App - for Business & Education"
                objectFit="fill"
                //                subTitle="Explore Sensitivities - Pre-Configured Scenarios"
                subTitle="Explore/Quantify Macro Risks to Trade, Energy & Net Zero"
                borderColor={
                  links == "risk2NZ app" ? borderColorToHighlight : "none"
                }
                //              Insert this in text below once ready:   <b>[YouTube risk2NZ Trailer link]</b>
                body={`Economic activity drives GHG emissions and there will be macroeconomic/policy/technology shocks en route to "Net Zero"  eg interest rate gyrations,
                currency/inflation, Nuclear fusion, etc. MEF’s risk2NZ App explores & quantifies such shock impacts to 2050 using pre-configured Macro/Energy forecast scenarios.
                The App is <b>fully configurable</b> and can be deployed in both University/Educational and Business/CPD contexts - see Tab list below: `}
              />
              <CustomizedAccordions
                title="risk2NZ - Subject Streams/Areas Covered in App"
                // Macro- rgba(84,77,160,0.25)
                // Energy-rgba(221, 110, 16,0.3)
                // Climate- rgba(46,139,87,0.15)
                // Finance- rgba(0,196,237,0.25)
                // General-rgba(84,77,160,0.025)
                body={`
                <table>
                <tbody style="font-size: 10px; text-align: left;";>
                <tr style="color: rgba(84,77,160,1);text-align: center;">
                  <th><strong>Tab Name</strong></th> <th><strong>Subject Area</strong></th>
                </tr>
                <tr style="color: rgba(84,77,160,1);background-color: rgba(84,77,160,.1);"><td style="border-top:2px solid rgba(84,77,160,1);"><b>MacroMap*</b></td > <td style="border-top:2px solid rgba(84,77,160,1);">see how scenarios impact national & Global macroeconomies via impact charts/heatmaps</td></tr>
                <tr style="color: rgba(84,77,160,1);"><td><b>Sunburst*</b></td > <td>see Country composition of key Global Macro Variables (eg Global GDP share)</td></tr>
                <tr style="color: rgba(84,77,160,1);background-color: rgba(84,77,160,.1)"><td><b>Trade</b></td> <td>view underlying model trade linkages explaining global shock transmissions behind scenarios</td></tr>
                <tr style="color: rgba(84,77,160,1);background-color: rgba(84,77,160,.1)"><td><b>Trade Products</b></td> <td>view data on bilateral trade linkages from UN COMTRADE database</td></tr>
                <tr style="color: rgba(84,77,160,1);"><td style="border-bottom:2px solid rgba(84,77,160,1);"><b>mGEM</b></td> <td style="border-bottom:2px solid rgba(84,77,160,1);">view underlying model linkages explaining shock transmissions behind scenarios + global trade links</td></tr>

                <tr style="color: rgba(221, 110, 16,1);background-color: rgba(221, 110, 16,0.05);"><td><b>EnergyMap*</b></td> <td>see how macroeconomic scenarios impact national & Global Energy variables via impacts charts & heatmaps</td></tr>
                <tr style="color: rgba(221, 110, 16,1);background-color: rgba(221, 110, 16,0.05);"><td><b>Sunburst</b></td> <td>look at Country composition of Global Energy Demand by Country/Use-sector and to 2050.</td></tr>
                <tr style="color: rgba(221, 110, 16,1);background-color: rgba(221, 110, 16,0.05);"><td><b>EnergyTradeLinks</b></td> <td>look at Country composition of Global Energy Demand by Country/Use-sector and to 2050.</td></tr>
                <tr style="color: rgba(221, 110, 16,1);background-color: rgba(221, 110, 16,0.05);"><td><b>EnergyFlow</b></td> <td>Sankey diagrams showing evolution of Energy Fuels/Mode used in Electricity Generation & Direct-Use to 2050</td></tr>
                <tr style="color: rgba(221, 110, 16,1);background-color: rgba(221, 110, 16,0.05);"><td style="border-bottom:2px solid rgba(221, 110, 16,1);"><b>PieLine*</b></td> <td style="border-bottom:2px solid rgba(221, 110, 16,1);">drilldown into the composition of Global Energy Demand/Generation by Country/Use-sector and to 2050</td></tr>

                <tr style="color: rgba(0, 160, 160,1);background-color: rgba(0, 160, 160,.1);"><td><b>GHGMap*</b></td> <td>see how scenarios impact national & Global environmental outcomes via impact charts/heatmaps</td></tr>
                <tr style="color: rgba(0, 160, 160,1);"><td><b>Sunburst</b></td> <td>gain overview of climate crisis challenge; view comparative GHG emissions by country and sector</td></tr>
                <tr style="color: rgba(0, 160, 160,1);background-color: rgba(0, 160, 160,.1);"><td><b>Industry*</b></td> <td>drilldown into the composition of overall GHG emissions by GHG gas and Country, Sector, Firm to 2050</td></tr>
                <tr style="color: rgba(0, 160, 160,1);"><td><b>Firms*</b></td> <td>Carbon Intensity data/projections to 2050 for high emissions firms by Sector & Country (TPI Data)</td></tr>
                <tr style="color: rgba(0, 160, 160,1);background-color: rgba(0, 160, 160,.1);"><td style="border-bottom:2px solid rgba(0, 160, 160,1);"><b>Montecarlo*</b></td> <td style="border-bottom:2px solid rgba(0, 160, 160,1);">explore risk around GHG emission trajectories to 2050</td></tr>

                <tr style="color: rgba(0,196,237,1.0);background-color: rgba(0,196,237,.2);"><td><b>PortfolioMap</b></td> <td>see how scenarios impact national & Global investment returns via impact charts/heatmaps</td></tr>
                <tr style="color: rgba(0,196,237,1.0);"><td><b>ESGrateDIY*</b></td> <td>specify user portfolio asset allocation to generate live, dynamic Esg rating to 2050</td></tr>
                <tr style="color: rgba(0,196,237,1.0);background-color: rgba(0,196,237,.2);"><td><b>Esg-Portfolio*</b></td> <td>see how scenarios impact financial portfolio Esg ratings with a Montecarlo risk fan overlay</td></tr>
                <tr style="color: rgba(0,196,237,1.0);"><td style="border-bottom:2px solid rgba(0,196,237,1.0);" ><b>Portfolio*</b></td> <td style="border-bottom:2px solid rgba(0,196,237,1.0);">see how scenarios impact financial portfolio returns with a Montecarlo risk fan overlay</td></tr>
                <tr style="color: rgba(0,196,237,1.0);background-color: rgba(0,196,237,.2);"><td style="border-bottom:2px solid rgba(0,196,237,1.0);" ><b>Portfolio-DIY*</b></td> <td style="border-bottom:2px solid rgba(0,196,237,1.0);">see how scenarios impact financial portfolio Esg ratings with a Montecarlo risk fan overlay</td></tr>

                <tr style="color: rgba(90, 90, 90,1);background-color: rgba(90, 90, 90,.1);"><td><b>MCQ</b></td> <td>see relevant textbook chapter multiple-choice questions (MCQ) that relate to the selected scenario</td></tr>
                <tr style="color: rgba(90, 90, 90,1);"><td><b>FAQ</b></td> <td>Frequently Asked Questions</td></tr>
                <tr style="color: rgba(90, 90, 90,1);background-color: rgba(90, 90, 90,.1);"><td style="border-bottom:2px solid rgba(90, 90, 90,1);"><b>Glossary</b></td> <td style="border-bottom:2px solid rgba(90, 90, 90,1);">an interactive, responsive Glossary of all economic, financial & environmental/Esg terms</td></tr>
                </table>
                <i style="font-size: 11px;"> * = have access to pre-configured scenarios to explore/quantify risk </i>
                `}
              />
              <CustomizedAccordions
                title="Explore Economic/Energy Risks to Net Zero"
                //              imgSrc="/images/[risk2NZ Capture1].jpg"
                body={`<b>risk2NZ</b> provides access to historical data & forecasts/scenarios to 2050 across global macroeconomic, climate, & energy variables via interactive,
                downloadable charts/maps for use in DIY client reports etc; risk2NZ can be tailored for business/financial risk analysis, marketing & HE/CPD uses. `}
              //               The full range of subject "Tabs" available in risk2NZ is set out below & this can be fully customized to the particular subject being taught:
              // <a title="industry Global Econometric Model">iGEM</a> allows the feed-through of mGEM global/national shocks to 12 industrial sectors (ISIC Rev. 4) across most/all of the major economies covered by mGEM.
              />
              <CustomizedAccordions
                title="ExploreFinance/Esg Risks"
                //              imgSrc="/images/[risk2NZ Capture1].jpg"
                body={`<a title="Environmental, Societal & Governance"> Esg </a> authenticity is also crucial for Fund Management but amid much “greenwashing” limited tools exist to aid financial
                professionals/educators to understand, assess, implement and communicate strategies. MEF's risk2NZ App “stress-tests” official climate/Net Zero projections using pre-configured (global) macroeconomic scenarios to illustrate alternative emissions pathways; it illustrates
                hard data on Esg ie which Countries, Sectors, Firms are key GHG emitters & their likely emissions trajectories to 2050.`}
              />
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <ContentCards
			imgSrc = {whatModelScheme}
                title="Bespoke Models"
                objectFit="contain"
                subTitle="Client Satellite Models - Domain-Specific"
                borderColor={
                  links == "bespoke models" ? borderColorToHighlight : "none"
                }
                body="Given sufficient domain-level data exists, MEF can estimate (structural) models for clients that are either free-standing or recursively-driven
                by outputs from MEF's global model suite. This allows client's own risk scenario/analysis to be fully-consistent with
                Global/national economic drivers."
              />
              <CustomizedAccordions
                title="Free-Standing Client Models"
                body=""
              />
              <CustomizedAccordions
                title="Client Models linked to mGEM"
                body={`eg1 <b>Exporters/SMEs</b> - managers can (cost-effectively) explore potential trading risk & opportunities in key global/national industry sectors. MEF can also construct SME-specific weighted indices of overall export prospects across all the SME's key export markets. mGEM shocks at a global/national level can then be translated into market-specific impacts for tailored SME risk analysis.<br><br>
                eg2 <b>Investment Committees</b> - analysts and consultants can...[   ]<br><br>
                see -  <a href='/why/case-study/DAS'> Client Case Study - DAS</a>`}
              />
            </Grid> */}
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default What;

// Mobile Apps and Webtools - powered by Global models/data
